import React from 'react'

const Cost = ({cost}) => {
    return (
        <div style={{color: '#f20000', fontSize: '16px', padding: '15px'}}>
            Cost: {cost} Tokens per Game
        </div>
    )
}
export default Cost